import { render } from "./page-content.vue?vue&type=template&id=6c4ccd2c&scoped=true"
import script from "./page-content.vue?vue&type=script&lang=js"
export * from "./page-content.vue?vue&type=script&lang=js"

import "./page-content.vue?vue&type=style&index=0&id=6c4ccd2c&scoped=true&lang=css"

import exportComponent from "/home/www/jenkins/jenkins_home/workspace/yizhige_production/yizhige_admin_pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c4ccd2c"]])

export default __exports__